<!-- <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ label }}</mat-label>
    <input matInput appFormatPrice [type]="type" [placeholder]="placeholder" [formControl]="control" (focus)="onFocus()" />
    <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        {{ errorMessage }}
    </mat-error>
</mat-form-field> -->

<div appearance="outline" class="full-width" >
    <input matInput [type]="type" [placeholder]="placeholder" [formControl]="control" class="input__customCore">
    <ng-content></ng-content>
    <mat-error class="errorTxt__custom" *ngIf="control?.invalid && (isSubmit)|| showSpan">
        {{ errorMessage }}
    </mat-error>
    <!-- <span class="errorTxt__custom" *ngIf="control?.invalid && (control?.dirty || isSubmit) ">
        {{ errorMessage }}
    </span> -->
</div>